import cart from '../helpers/cart-helper'
import refs from '../helpers/refs'
import ButtonHelper from '../helpers/button-helper'

class CProductCompare {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    if (!Array.isArray(this.$refs.compareAddToCartButton)) {
      this.$refs.compareAddToCartButton = [this.$refs.compareAddToCartButton]
    }

    // Add to cart script
    this.$refs.compareAddToCartButton.forEach((button) => {
      const innerElem =
        button.children.length > 0 ? button.children[0] : button
      // Look for variant-id progressively going up the heirarchy
      // Done this way to avoid grabbing main product variant ID if on product page
      const variantID = button.closest('[data-default-variant-id]').dataset
        .defaultVariantId
      const buttonHelper = new ButtonHelper(button, innerElem)

      if (button) {
        button.addEventListener('click', (e) => {
          // Handle iOS Safari's buggy click event behavior
          e.preventDefault()
          e.stopPropagation()

          // Set text to loading
          buttonHelper.setPendingState()

          cart
            .addProductsToCart([
              {
                id: variantID,
                quantity: 1
              }
            ])
            .then(() => {
              // Done adding to cart state
              buttonHelper.setDoneState()

              // Reset to initial state
              buttonHelper.resetStateOnDelay()
            })
        })
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-product-compare]')
    .forEach(el => new CProductCompare(el))
})
